import { render, staticRenderFns } from "./all_no_nationality.vue?vue&type=template&id=9c81f00e&scoped=true"
import script from "./all_no_nationality.vue?vue&type=script&lang=js"
export * from "./all_no_nationality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c81f00e",
  null
  
)

export default component.exports